import { useSearchParams } from 'react-router';

import { useInsightsChannelAccess } from './hooks/useInsightsChannelAccess';
import { WIDGET } from './constants';
import ChannelAccessDeniedState from 'src/components/channel-access-denied/ChannelAccessDeniedState';
import Spinner from 'src/components/spinner';
import { Routes } from 'src/utils/enums';

const WIDGET_PATHS: ReadonlySet<string> = new Set([
  Routes.SOLVE_INSIGHTS_INSIGHT_CARD,
  Routes.SOLVE_INSIGHTS_INSIGHT_CARD_VIEW,
  Routes.SOLVE_INSIGHTS_TOPIC_DETAIL,
  Routes.SOLVE_INSIGHTS_TOPIC_DETAIL_PARENT,
]);

const PRODUCT_MODE_PATHS: ReadonlySet<string> = new Set([
  Routes.SOLVE_INSIGHTS_ARTICLE_DETAIL,
  Routes.SOLVE_INSIGHTS_WORKFLOW_DETAIL,
]);

/** Detail pages show one channel's data: topics and cards are widget, the rest follow `product_mode`. */
export default function SolveInsightsChannelGuard({
  children,
  path,
}: {
  children: React.ReactNode;
  path: string;
}) {
  const [searchParams] = useSearchParams();
  const { isLoading, isRestricted } = useInsightsChannelAccess();

  if (!WIDGET_PATHS.has(path) && !PRODUCT_MODE_PATHS.has(path)) {
    return <>{children}</>;
  }
  if (isLoading) {
    return <Spinner />;
  }
  const productMode = PRODUCT_MODE_PATHS.has(path)
    ? (searchParams.get('product_mode') ?? WIDGET)
    : WIDGET;
  if (isRestricted(productMode)) {
    return <ChannelAccessDeniedState withPanel />;
  }
  return <>{children}</>;
}
